import React from 'react';
import { Formik, Form } from 'formik';
import {
  Button,
  Card,
  Container,
  Grid,
  LinearProgress,
  MenuItem
} from '@material-ui/core';
import * as yup from 'yup';
import Header from './Header';
import MyRadioButton from './MyRadioButton';
import MyTextInput from './MyTextInput';
import MySelect from './MySelect';

function WeightliftingStats({ formData, setFormData, nextPage, prevPage }) {
  return (
    <React.Fragment>
      <Header title="What are your PR's?" />
      <Container maxWidth="md" style={{ height: '500px', padding: '1rem' }}>
        <Card raised>
          <Formik
            initialValues={formData}
            validationSchema={yup.object({
              weightliftingStats: yup.object({
                snatch: yup.number().required('Required'),
                cleanJerk: yup.number().required('Required'),
                age: yup.number().required('Required'),
                bw: yup.number().required('Required')
              })
            })}
            onSubmit={async (values, actions) => {
              actions.setSubmitting(true);
              setFormData(values);
              try {
                nextPage();
              } catch (error) {
                console.error('Error @WeightliftingStats calculateResults():', error);
              }
            }}
          >
            {formik => (
              <Form>
                <Container maxWidth="sm" style={{ padding: '1rem' }}>
                  <Grid container justify="center">
                    <Grid item xs={3}>
                      <MyRadioButton name="weightliftingStats.units" type="radio" value="kg" label="Kilograms" />
                    </Grid>
                    <Grid item xs={3}>
                      <MyRadioButton name="weightliftingStats.units" type="radio" value="lb" label="Pounds" />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <MyTextInput name="weightliftingStats.snatch" type="number" label="1RM Snatch" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MyTextInput name="weightliftingStats.cleanJerk" type="number" label="1RM Clean and Jerk" />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} justify="center">
                    <Grid item xs={12} sm={3}>
                      <MySelect name="weightliftingStats.gender" label="Gender" value={formik.values.weightliftingStats.gender}>
                        <MenuItem value="m">Male</MenuItem>
                        <MenuItem value="f">Female</MenuItem>
                      </MySelect>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <MyTextInput name="weightliftingStats.age" type="number" label="Age" />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <MyTextInput name="weightliftingStats.bw" type="number" label="Bodyweight" />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Button disabled={formik.isSubmitting} variant="contained" onClick={prevPage} fullWidth>Back</Button>
                    </Grid>
                    <Grid item xs={8} style={{ margin: 'auto' }}>
                      {formik.isSubmitting ? (
                        <LinearProgress />
                      ) : (
                        <Button variant="contained" color="primary" type="submit" fullWidth >Next</Button>
                      )}
                    </Grid>
                  </Grid>
                  {/* <pre>{JSON.stringify(formik.values, null, 2)}</pre>
                  <pre>{JSON.stringify(formik.errors, null, 2)}</pre> */}
                </Container>
              </Form>
            )}
          </Formik>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default WeightliftingStats;